import styled from "styled-components";


export const Container = styled.main`
    width: 100vw;
    height: 90vh;
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    background: transparent;
`


export const InfoContainer = styled.div`
    margin:30px ;
    height: 80%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`

export const TitleContainer = styled.div`
    width: 100%;
    height: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
    font-size: 3rem ;
`
export const Subtitle = styled.h3 `
    font-size: 2rem;
    font-family: 'Klee One', cursive;
`
export const Text = styled.p`
    font-size: 1.5rem;    
`

